import styled, { css } from "styled-components"
import { FontFamilyRegular } from "./typography.styles"
import Breakpoints from "./breakpoints"

export const FormContainer = styled.form`
  grid-column: 1 / -1;
`

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-column: 1 / -1;
  padding: 0 20px 24px 20px;
  grid-gap: 24px;

  @media (min-width: ${Breakpoints.md}) {
    grid-template-columns: 1fr 1fr;
    grid-column: 3 / 11;
    grid-template-rows: auto auto auto;
    & > :nth-last-child(2) {
      grid-column: span 2;
    }
  }

  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 4 / 10;
  }
`

export const FormSubmitButton = styled.button`
  display: flex;
  justify-content: center;
  ${FontFamilyRegular}
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  background-color: var(--burnt-orange);
  color: var(--white);
  padding: 16px 32px;
  margin-top: 30px;
  border: none;
  outline: none;
  justify-self: center;
  align-self: center;
  cursor: pointer;
  user-select: none;

  @media (min-width: ${Breakpoints.md}) {
    grid-column: span 2;
  }

  ${props =>
    props.disabled &&
    css`
      background-color: #8c6053;
      color: var(--dark-mode-heading);
      cursor: initial;
    `}
`

export const ValidationContainer = styled.div`
  min-height: 78px;
  grid-column: 1 / -1;
  display: flex;
  justify-content: center;
  margin: 32px 0;

  @media (min-width: ${Breakpoints.lg}) {
    margin: 32px 0 0 0;
  }
`

const MessageBlock = styled.div`
  display: inline-flex;
  margin: -16px 20px 32px 20px;
  grid-column: 1 / -1;
  justify-self: center;
  align-items: center;
  padding: 24px 32px;

  & > img:first-child {
    margin-right: 16px;
  }

  ${FontFamilyRegular}
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 170%;

  color: #2e2e2e;

  a,
  a:link,
  a:visited,
  a:active {
    color: var(--burnt-orange);
    text-decoration: none;
  }
`

export const SuccessBlock = styled(MessageBlock)`
  background: #f6faf7;
  border: 1px solid #4f9866;
  box-sizing: border-box;
  border-radius: 2px;
`
export const ErrorBlock = styled(MessageBlock)`
  background: #fcf4f4;
  border: 1px solid #ca3232;
  box-sizing: border-box;
  border-radius: 2px;
`
